import PicksGrupoPoolGroup from './PicksGrupoPoolGroup';
export default PicksGrupoPoolGroup; 